import API from 'services/api';

export const getPaymentMethods = () => {
  return API.get('/api/root/payment-method/all').then(res => res?.data);
};
